export class Need {
  needid: number;
  description: string;
}
